import { PaywallDispatch } from '~teacher/components/PaywallDialog';
import { proCheck } from '~teacher/util/proCheck';

import axios from '../../localAxios';
import { MoveTask } from '../MoveTask';
import { moveURL } from '../url';

export interface RestoreQuizFolderParam {
  folderIds?: number[];
  quizIds?: number[];
  parentId: number;
  paywallDispatch?: PaywallDispatch;
  quizLimitPaywallDispatch?: PaywallDispatch;
}

export type RestoreQuizFolderResponse = Record<string, never>;

export async function restoreQuizFolder({
  folderIds = [],
  parentId,
  quizIds = [],
}: RestoreQuizFolderParam) {
  if (proCheck.canRestoreTrash()) {
    const url = moveURL();
    const response = await axios.put<RestoreQuizFolderResponse>(url.href, {
      folderIds: folderIds,
      parentId: parentId,
      quizIds: quizIds,
      task: MoveTask.RESTORE,
    });
    return response.data;
  }
  // Don't handle paywall dispatch here (already handled in onMutate in useRestoreQuizFolder
  // as part of optimistic cache update)
}
